import { render } from "./ModalClusterConfigWizard.vue?vue&type=template&id=5c28d23c&scoped=true&ts=true"
import script from "./ModalClusterConfigWizard.vue?vue&type=script&lang=ts"
export * from "./ModalClusterConfigWizard.vue?vue&type=script&lang=ts"

import "./ModalClusterConfigWizard.vue?vue&type=style&index=0&id=5c28d23c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c28d23c"]])

export default __exports__